import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classnames';
import colors from '@spotify-internal/encore-foundation';
import styles from './index.module.scss';

export function LoadingIndicator({ size, style }) {
  const css = cn({
    [styles['loading_indicator--sm']]: size === 'sm',
    [styles['loading_indicator--md']]: size === 'md',
    [styles['loading_indicator--lg']]: size === 'lg',
  });

  const color = colors['grey-40'];

  return (
    <div style={style} className={styles.loading_indicator} data-testid="loading-indicator">
      <svg
        className={css}
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 1 100"
        xmlSpace="preserve"
      >
        <circle
          className={styles['loading_indicator-circle']}
          fill={color}
          stroke="none"
          cx="-140"
          cy="50"
          r="32"
        />
        <circle
          className={styles['loading_indicator-circle']}
          fill={color}
          stroke="none"
          cx="0"
          cy="50"
          r="32"
        />
        <circle
          className={styles['loading_indicator-circle']}
          fill={color}
          stroke="none"
          cx="140"
          cy="50"
          r="32"
        />
      </svg>
    </div>
  );
}

LoadingIndicator.defaultProps = {
  size: 'sm',
};

LoadingIndicator.propTypes = {
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  style: PropTypes.shape(),
};
